import axios from 'axios'

const currentUrl = window.location.href
let baseURL = 'https://api.fitbase.io/api/v1.1/'
let domain = document.getElementById('app').dataset.domain

if (currentUrl.includes('pandem1c.devops')){
    baseURL = 'https://api.pandem1c.devops.fitbase.io/api/v1.1/'
    domain = 'pandem1c'
}else if (currentUrl.includes('staging')){
    baseURL = 'https://api-staging.dev.fitbase.team/api/v1.1/'
    domain = 'staging'
}else if (currentUrl.includes('test.devops')){
    baseURL = 'https://api-test.devops.fitbase.io/api/v1.1/'
    domain = 'test'
}else if (currentUrl.includes('fitbase.local') || currentUrl.includes('localhost')){
    baseURL = 'http://api.fitbase.local/api/v1.1/'
    domain = 'demo'
}else if (currentUrl.includes('predprod')){
    baseURL = 'https://api.predprod.devops.fitbase.io/api/v1.1/'
    domain = 'predprod'
}

const instance = axios.create({
    baseURL: baseURL,
    headers: {
        Club: domain,
        Source: 'personal'
    }
})

instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('fitbase_token');

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

export default instance
